export const getFromLocalStorage = (key: string, value?: string) => {
  const item = window.localStorage.getItem(key);
  const object = item && JSON.parse(item);
  if (!value) return object;

  const valueFromObject = object && object[value];

  return valueFromObject;
};
